import React from 'react';

// Styles & Assets
import styles from './ButtonFilter.module.css';
import { RiFilterFill } from 'react-icons/ri';

// Interfaces
interface Props {
    filterActive: boolean
    style?: React.CSSProperties
}

const ButtonFilter: React.FC<Props> = ({ filterActive, style }) => {

    return (
        <div className={styles.container} style={style}>
            <RiFilterFill />
            {filterActive && <div className={styles.ballFilter}></div>}
        </div>
    );
};

export default ButtonFilter;